import { render, staticRenderFns } from "./OrdersHafciarnia.vue?vue&type=template&id=31a958d7&"
import script from "./OrdersHafciarnia.vue?vue&type=script&lang=js&"
export * from "./OrdersHafciarnia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports